import { MinutasPronosticoElementAPI } from '@/domain/entities/Api'
import { MutationTree } from 'vuex'
import { MinutasPronosticoState, StoreError } from './types'

export const mutations: MutationTree<MinutasPronosticoState> = {
  MINUTAS_PRONOSTICO_FETCHED (state, payload: MinutasPronosticoElementAPI[]) {
    state.error = { state: false }
    state.minutasPronostico = payload
    state.isLoaded = true
  },
  MINUTAS_PRONOSTICO_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  MINUTAS_PRONOSTICO_SET_API_DESCARGA (state, payload: string) {
    state.link_descarga = payload
  },
  MINUTAS_PRONOSTICO_DELETED (state) {
    state.error = { state: false }
    state.minutasPronostico = []
  }
}
